module.exports = __webpack_public_path__ + "static/media/bathroom.42cdb8be.jpg";